import React from 'react';
import { Field, Label, Control, Message } from '@radix-ui/react-form';

interface FormInputProps {
  id: string;
  type: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const FormInput: React.FC<FormInputProps> = ({ id, type, label, placeholder, required = true, value, onChange }) => {
  return (
    <Field name={id} className="flex flex-col gap-2">
      <Label htmlFor={id} className="text-sm font-medium text-secondaryNeutral-12">
        {label}
      </Label>
      <Control asChild>
        <input
          id={id}
          type={type}
          className="w-full h-10 py-2 border border-secondaryNeutralAlpha-5 border-opacity-[12.55%] rounded-md focus:outline-none focus:ring-2 focus:ring-primaryAccent-9"
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={onChange}
        />
      </Control>
      <Message match="valueMissing" className="text-red-500 text-sm">
        {`${label} is required`}
      </Message>
    </Field>
  );
};

export default FormInput;
